// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__w5dRL","l2":"styles_l2__xY+-9"};